import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {Barcode} from './model';

export interface BarcodeState extends EntityState<Barcode> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'Barcode' })
export class Store extends EntityStore<BarcodeState> {

  constructor() {
    super();
  }

}
